import React, { useState } from 'react'
import { notifyPatientSpotted } from '../../services/apis/dispense/routeAudit'
import { toTitleCase } from '../../utils/helper/routeAuditUi'

export const RouteAccessBlockedNotice = ({
	data,
	pharmacyId,
	enableNotifyAssignedUser = false,
	className = 'mb-3'
}) => {
	const [spottedLoading, setSpottedLoading] = useState(false)
	const [spottedMessage, setSpottedMessage] = useState('')
	const [spottedError, setSpottedError] = useState('')

	if (data?.route_access?.allowed !== false) {
		return null
	}

	const canNotifyAssignedUser = enableNotifyAssignedUser && data?.assigned_route_owner?.type === 'driver'

	const handlePatientSpotted = () => {
		if (!data?.id || !pharmacyId || !navigator?.geolocation) {
			setSpottedError('Live location is unavailable on this device.')
			return
		}

		setSpottedLoading(true)
		setSpottedError('')
		setSpottedMessage('')

		navigator.geolocation.getCurrentPosition(
			async (position) => {
				try {
					const response = await notifyPatientSpotted({
						pharmacyId,
						patientId: data.id,
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
					})
					setSpottedMessage(`Notified ${response?.target_driver_name || 'assigned delivery user'}.`)
				} catch (error) {
					setSpottedError(error?.response?.data?.data?.error?.message || error?.response?.data?.message || 'Unable to send the patient spotted notification.')
				} finally {
					setSpottedLoading(false)
				}
			},
			() => {
				setSpottedLoading(false)
				setSpottedError('Location permission is required to notify the assigned delivery user.')
			},
			{ enableHighAccuracy: true, timeout: 10000 }
		)
	}

	return (
		<div className={`${className} rounded-lg border border-red-200 bg-red-50 px-3 py-3 text-sm text-red-700`}>
			<p className="font-semibold">Delivery blocked for this patient.</p>
			<p>{data?.route_access?.reason || 'This patient has been handed over to another user.'}</p>
			{data?.assigned_route_owner?.name ? (
				<p className="mt-1 text-xs text-red-600">Assigned user: {toTitleCase(data.assigned_route_owner.name)}</p>
			) : null}
			{canNotifyAssignedUser ? (
				<div className="mt-3 flex flex-wrap items-center gap-2">
					<button
						type="button"
						onClick={handlePatientSpotted}
						disabled={spottedLoading}
						className="rounded-md bg-red-600 px-3 py-2 text-xs font-semibold text-white disabled:cursor-not-allowed disabled:opacity-70"
					>
						{spottedLoading ? 'Sending...' : 'Notify Assigned User'}
					</button>
					{spottedMessage ? <span className="text-xs text-green-700">{spottedMessage}</span> : null}
				</div>
			) : null}
			{spottedError ? <p className="mt-2 text-xs text-red-700">{spottedError}</p> : null}
		</div>
	)
}
